import { render, staticRenderFns } from "./SingleSignOnFacebook.vue?vue&type=template&id=7878e36d"
import script from "./SingleSignOnFacebook.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSignOnFacebook.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports